import Iconify from 'src/components/Iconify';
import useInadimplencia from 'src/hooks/useInadimplencia';

export const BANNER_HEIGHT = 20;

export default function InadimplenciaBanner() {
  const { ativo, mensagem } = useInadimplencia();

  if (!ativo) return null;

  return (
    <div
      role="alert"
      className="fixed top-0 left-0 right-0 w-full bg-red-600 text-white text-center px-3 text-[10px] font-medium shadow-sm flex items-center justify-center gap-1"
      style={{ height: BANNER_HEIGHT, zIndex: 2147483647 }}
    >
      <Iconify icon="eva:alert-triangle-outline" width={12} height={12} />
      <span>{mensagem}</span>
    </div>
  );
}
